import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import DatePickInputer from 'components/DatePickInputer';
import classNames from 'classnames';
import './style.css';
export const INPUT_TYPE = {
  TEXT: 'TEXT',
  SELECT: 'SELECT',
  RADIO: 'RADIO',
  DATEPICKER: 'DATEPICKER',
  CUSTOM: 'CUSTOM',
  FILE: 'FILE',
};

export default class FormItem extends Component {
  renderTextBox() {
    const {
      itemName,
      itemValue,
      onChange,
    } = this.props;

    return (
      <input
        className="form-control"
        id={itemName}
        value={itemValue}
        type="text"
        onChange={onChange}
      />
    );
  }

  renderRadios() {
    const {
      itemName,
      itemValue,
      options,
      onChange,
    } = this.props;

    return options.map((option) => {
      const itemKey = itemName + '_' + option.value;
      const checkedValue = option.value;
      return (
        <label
          htmlFor={itemKey}
          className="radio-inline"
          key={itemKey}
        >
          <input
            id={itemKey}
            name={itemName}
            value={option.value}
            type="radio"
            onChange={() => {
              onChange(checkedValue);
            }}
            checked={checkedValue === itemValue}
          />
          {option.label}
        </label>
      );
    });
  }


  renderSelect() {
    const {
      itemValue,
      itemName,
      options,
      onChange,
      searchable = false,
      clearable = false,
    } = this.props;

    return (
      <Select
        name={itemName}
        options={options}
        value={itemValue}
        searchable={searchable}
        clearable={clearable}
        placeholder=""
        onChange={onChange}
      />
    );
  }

  renderDatePicker() {
    const {
      itemValue,
      onChange,
      allowEmpty,
      minDate,
      disabled,
    } = this.props;

    return (
      <DatePickInputer
        initialMonth={itemValue}
        allowEmpty={allowEmpty}
        handleDayClick={(event, value) => {
          onChange(value);
        }}
        minDate={minDate}
        disabled={disabled}
      />
    );
  }

  renderFileInputer() {
    const {
      itemName,
      itemValue,
      onChange,
      accept,
    } = this.props;

    return (
      <input
        className="form-control"
        style={{ color: '#999', height: 'auto', padding: '5px' }}
        id={itemName}
        value={itemValue}
        type="file"
        onChange={onChange}
        accept={accept}
      />
    );
  }

  renderFormItem() {
    const inputType = this.props.inputType;
    switch (inputType) {
      case INPUT_TYPE.TEXT:
        return this.renderTextBox();
      case INPUT_TYPE.RADIO:
        return this.renderRadios();
      case INPUT_TYPE.SELECT:
        return this.renderSelect();
      case INPUT_TYPE.DATEPICKER:
        return this.renderDatePicker();
      case INPUT_TYPE.CUSTOM:
        return this.props.children;
      case INPUT_TYPE.FILE:
        return this.renderFileInputer();
      default:
        return this.renderTextBox();
    }
  }

  render() {
    const {
      itemName,
      labelText,
      require,
      errorMessage,
      style,
    } = this.props;

    return (
      <div
        className={
          classNames({
            'formItem': true,
            'form-group': true,
            require,
          })
        }
        style={style}
      >
        <label htmlFor={itemName} className="col-sm-4 control-label">{labelText}{labelText ? ' : ' : ''}</label>
        <div className="col-sm-8">
          {this.renderFormItem()}
          <div className="text-danger" style={{ paddingLeft: 10 }}>
            {errorMessage}
          </div>
        </div>
      </div>
    );
  }
}

FormItem.propTypes = {
  itemName: PropTypes.string.isRequired,
  labelText: PropTypes.object.isRequired,
  style: PropTypes.object,
  itemValue: PropTypes.string.isRequired,
  inputType: PropTypes.oneOf(Object.values(INPUT_TYPE)),
  options: PropTypes.array,
  children: PropTypes.array,
  onChange: PropTypes.func,
  searchable: PropTypes.bool, // Select 是否允許搜尋
  clearable: PropTypes.bool, // Select 是否允許清除
  require: PropTypes.bool, // 是否顯示必填*
  allowEmpty: PropTypes.bool, // DatePicker 是否允許空值
  accept: PropTypes.string, // FILE 允許的副檔名
  minDate: PropTypes.string,
  errorMessage: PropTypes.bool,
  disabled: PropTypes.bool,
};



/** WEBPACK FOOTER **
 ** D:/a/1/s/Tube.Frontend/src/containers/App/screens/Foundation/screens/MyData/components/FormItem/index.js
 **/